var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3704 10.9951C14.55 11.1826 14.651 11.4369 14.651 11.7021C14.651 11.9672 14.55 12.2215 14.3704 12.4091L9.96876 17.0021C9.79024 17.1846 9.54988 17.2863 9.29992 17.285C9.04995 17.2837 8.81059 17.1795 8.63384 16.995C8.45709 16.8106 8.35723 16.5608 8.35597 16.3C8.35471 16.0392 8.45214 15.7884 8.6271 15.6021L12.3646 11.7021L8.6271 7.80207C8.45214 7.61578 8.35471 7.36497 8.35597 7.10414C8.35723 6.84331 8.45709 6.59354 8.63384 6.4091C8.81059 6.22467 9.04995 6.12047 9.29992 6.11915C9.54988 6.11784 9.79024 6.21951 9.96876 6.40207L14.3704 10.9951Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.6430aa9106ee1025d7b6e35f70fa1c07.svg";
export { ForwardRef as ReactComponent };